export const SpinnerLoaderSearch = () => {
  return <div className="d-flex align-items-center justify-content-center mt-2">
    <div className="spinner"></div>
  </div>
};
